import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Modal, Image } from 'react-bootstrap';
import { BsThreeDots } from 'react-icons/bs';
import { FaVolumeMute } from 'react-icons/fa';

import { useAuth } from '../hooks/auth';
import { useToast } from '../hooks/toast';
import { useMessage } from '../hooks/message';
import api from '../services/apiClient';
import { unescapeHtml } from '../services/function';

import CheckCircleIcon from '../assets/icon/checkCircle.svg';
import ViewIcon from '../assets/icon/view.svg';
import { useUserConfig } from '../hooks/userConfig';
import { useUserStatus } from '../hooks/userStatus';

interface clientsWaiting {
  seqAtendimento: number;
  nomeCliente: string;
  emailCliente: string;
  nomeClinica: string;
  duvida: string;
  nomeProduto: string;
  seqStatusAtendimento: number;
}

const ChatActive: React.FC = () => {
  const { dataConnection } = useAuth();
  const { hubConnection } = dataConnection;
  const navigate = useNavigate();
  const { userDepartament } = useUserConfig();
  const { userSubordinado, loadUserSubordinado } = useUserStatus();

  const { addToast } = useToast();
  const {
    clientsAccepted,
    SetClientsAccepted,
    clientWaiting,
    loadClientsWaiting,
    chatEmAndamento,
    loadChatEmAndamento,
    alertNewClientIdTimeout,
  } = useMessage();

  const [showModalDuvida, setShowModalDuvida] = useState(false);
  const [dadosModalDuvida, setDadosModalDuvida] = useState<clientsWaiting>(
    {} as clientsWaiting
  );

  const buttonAccept = useRef<HTMLButtonElement>(null);
  const buttonRefuse = useRef<HTMLButtonElement>(null);

  const handleAcceptService = (id: number): void => {
    if (buttonAccept.current) {
      buttonAccept.current.setAttribute('disabled', 'true');
      buttonAccept.current.innerText = 'Aguarde...';
    }

    const token = localStorage.getItem('@LiveChat:token');

    api
      .put(
        `/SolicitacaoAtendimento?idSupportRequest=${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        const dataResponse = response.data;

        if (dataResponse.success) {
          SetClientsAccepted([...clientsAccepted, dataResponse.data]);

          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Serviço aceito com sucesso',
          });

          loadClientsWaiting();

          navigate(`/chat?id=${id}`);
        }
      });
  };

  const handleSupervisorChat = (id: number): void => {
    navigate(`/chatSupervisor?id=${id}`);
  };

  const handleRefuseService = (id: number): void => {
    if (buttonRefuse.current) {
      buttonRefuse.current.setAttribute('disabled', 'true');
      buttonRefuse.current.innerText = 'Aguarde...';
    }

    const token = localStorage.getItem('@LiveChat:token');

    api
      .post(
        `/SolicitacaoAtendimento/RefuseChat?idSupportRequest=${id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        const dataResponse = response.data;

        if (dataResponse.success) {
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Atendimento recusado com sucesso',
          });

          loadClientsWaiting();
        }
      });
  };

  useEffect(() => {
    loadClientsWaiting();
    loadUserSubordinado();
    loadChatEmAndamento();
    Notification.requestPermission();
  }, []);

  useEffect(() => {
    hubConnection?.on('UpdateNewChatSupervisor', () => {
      loadChatEmAndamento();
    });
  }, [hubConnection]);

  return (
    <div className="h-100">
      <h1 className="ms-2" style={{ fontSize: '2.5rem', fontWeight: '600' }}>
        Chats Ativos
      </h1>

      <Modal
        show={showModalDuvida}
        onHide={() => setShowModalDuvida(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title className="fw-bold" style={{ fontSize: '1.3rem' }}>
            Dúvida
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ fontSize: '1.3rem', color: '#828282', fontWeight: '500' }}
        >
          {dadosModalDuvida.duvida}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModalDuvida(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      <section>
        <div
          className="card ms-2 me-2 border-secundary mb-5 bg-body position-static"
          style={{
            borderRadius: '0.68rem',
            height: 'Calc(100vh - 14rem)',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          }}
        >
          <div
            className="table-responsive overflow-hidden"
            style={{ borderRadius: '0.68rem', borderColor: 'transparent' }}
          >
            <table className="table table-hover table-nowrap mb-0">
              <thead
                className="small fw-light text-dark"
                style={{
                  backgroundColor: '#D9D9D9',
                  borderRadius: '0.68rem!important',
                  fontSize: '1.25rem',
                }}
              >
                <tr>
                  <th className="col ms-3">Nome</th>
                  <th className="col">Operador</th>
                  <th className="col">Empresa</th>
                  <th className="col">Produto/Nº Contrato</th>
                  <th className="col">Departamento</th>
                  <th className="col">Dúvida</th>
                  <th className="col"> </th>
                </tr>
                <tr className="text-dark bg-white fw-bold">
                  <td className="text-dark" colSpan={7}>
                    Em espera:
                  </td>
                </tr>
              </thead>
              <tbody
                className="text-dark"
                style={{ borderColor: 'transparent', fontSize: '1.25rem' }}
              >
                {clientWaiting !== undefined
                  ? clientWaiting.map((client) => (
                      <tr
                        key={client.seqAtendimento}
                        style={{
                          backgroundColor: `${
                            client.corFundoLinha === 'S'
                              ? client.corDepartamento
                              : '#F4F4F4'
                          }`,
                        }}
                      >
                        <td className="ps-5">{client.nomeCliente}</td>
                        <td> </td>
                        <td>{client.nomeClinica}</td>
                        <td>{client.nomeProduto}</td>
                        <td>
                          <div
                            className="rounded-pill px-3"
                            style={{
                              backgroundColor: `${
                                client.corFundoLinha !== 'S'
                                  ? client.corDepartamento
                                  : ''
                              }`,
                              color: `${
                                client.corFundoLinha !== 'S' ? '#fff' : ''
                              }`,
                              display: 'inline-block',
                              maxWidth: '100%',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {client.nomeDepartamento}
                          </div>
                        </td>
                        <td>
                          {unescapeHtml(client.duvida.substring(0, 60))}
                          <Button
                            size="sm"
                            className="ms-2"
                            onClick={() => {
                              setDadosModalDuvida(client);
                              setShowModalDuvida(true);
                            }}
                          >
                            <BsThreeDots size={16} />
                          </Button>
                        </td>
                        <td className="text-end m-0 p-1">
                          <div className="d-flex">
                            <Button
                              variant="danger"
                              ref={buttonRefuse}
                              onClick={() => {
                                clearInterval(alertNewClientIdTimeout);
                              }}
                            >
                              <FaVolumeMute />
                            </Button>
                            <Button
                              className="ms-1"
                              ref={buttonAccept}
                              onClick={() =>
                                handleAcceptService(client.seqAtendimento)
                              }
                            >
                              <div className="d-flex align-items-center justify-content-center">
                                <Image
                                  src={CheckCircleIcon}
                                  style={{ height: '1.7rem', width: '1.7rem' }}
                                  alt="Aceitar"
                                />
                                <span
                                  className="ms-2 fw-bold"
                                  style={{
                                    fontWeight: '600',
                                    fontSize: '1.25rem',
                                  }}
                                >
                                  aceitar
                                </span>
                              </div>
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
              <thead
                className="small fw-light text-dark "
                style={{
                  backgroundColor: '#D9D9D9',
                  borderRadius: '0.68rem!important',
                  fontSize: '1.25rem',
                  borderColor: 'transparent',
                }}
              >
                <tr
                  className="text-dark bg-white fw-bold"
                  style={{ borderColor: 'transparent' }}
                >
                  <td
                    className="text-dark"
                    colSpan={7}
                    style={{ borderColor: '#D9D9D9' }}
                  >
                    Em atendimento:
                  </td>
                </tr>
              </thead>
              <tbody
                className="text-dark "
                style={{
                  borderColor: 'transparent',
                  fontSize: '1.25rem',
                  backgroundColor: '#F4F4F4',
                }}
              >
                {chatEmAndamento !== undefined
                  ? chatEmAndamento.map((client) => (
                      <tr
                        key={client.seqAtendimento}
                        style={{
                          backgroundColor: `${
                            client.corFundoLinha === 'S'
                              ? client.corDepartamento
                              : '#F4F4F4'
                          }`,
                        }}
                      >
                        <td className="ps-5">{client.nomeCliente}</td>
                        <td>{client.nomeUsuario}</td>
                        <td>{client.nomeClinica}</td>
                        <td>{client.nomeProduto}</td>
                        <td>
                          <div
                            className="rounded-pill px-3"
                            style={{
                              backgroundColor: `${
                                client.corFundoLinha !== 'S'
                                  ? client.corDepartamento
                                  : ''
                              }`,
                              color: `${
                                client.corFundoLinha !== 'S' ? '#fff' : ''
                              }`,
                              display: 'inline-block',
                              maxWidth: '100%',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {client.nomeDepartamento}
                          </div>
                        </td>
                        <td>
                          {unescapeHtml(client.duvida.substring(0, 60))}
                          <Button
                            size="sm"
                            className="ms-2"
                            onClick={() => {
                              setDadosModalDuvida(client);
                              setShowModalDuvida(true);
                            }}
                          >
                            <BsThreeDots size={16} />
                          </Button>
                        </td>
                        <td className="text-end m-0 p-1">
                          <div className="d-flex ">
                            {userSubordinado.find(
                              (user) =>
                                user.seqUsuarioSubordinado ===
                                client.userAtendimento
                            ) && (
                              <Button
                                className="ms-1"
                                style={{
                                  backgroundColor: '#FFA300',
                                  borderColor: '#FFA300',
                                }}
                                ref={buttonAccept}
                                onClick={() =>
                                  handleSupervisorChat(client.seqAtendimento)
                                }
                              >
                                <Image
                                  src={ViewIcon}
                                  style={{ height: '1.7rem', width: '1.7rem' }}
                                  alt="Aceitar"
                                />
                                <span
                                  className="ms-2 fw-bold"
                                  style={{
                                    fontWeight: '600',
                                    fontSize: '1.25rem',
                                  }}
                                >
                                  supervisionar
                                </span>
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChatActive;
